import React from 'react';
import clsx from 'clsx';
import { ExperimentStatus as ExperimentStatusEnum } from 'apps/experiments/src/types';
import { SvgIconReact, SvgIconType } from 'common/components/svg-icon';
import { useTranslation } from 'common/i18n/hooks';
import styles from './index.module.styl';
const PROGRESS_CIRCLE_RADIUS = 8;
type ExperimentStatusProps = {
  status: ExperimentStatusEnum;
  percent: number;
  variant?: string;
};
export function ExperimentStatus(_ref: ExperimentStatusProps) {
  let {
    status,
    percent,
    variant
  }: ExperimentStatusProps = _ref;
  const i18n = useTranslation();
  let label = "";
  let className: string;
  let icon: SvgIconType | undefined = undefined;
  let showProgress: boolean = false;
  switch (status) {
    case ExperimentStatusEnum.DRAFT:
      label = i18n.t("experiments.status.draft");
      icon = "circle-dashed";
      className = styles.draft;
      break;
    case ExperimentStatusEnum.CONFIGURED:
      label = i18n.t("experiments.status.configured");
      icon = "circle";
      className = styles.draft;
      break;
    case ExperimentStatusEnum.ACTIVE:
      label = i18n.t("experiments.status.active");
      icon = "circle";
      className = styles.active;
      showProgress = true;
      break;
    case ExperimentStatusEnum.CONCLUDED:
      label = i18n.t("experiments.status.concluded");
      icon = "circle-checkmark";
      className = styles.concluded;
      break;
    case ExperimentStatusEnum.SUCCESS:
      label = i18n.t("experiments.status.success", {
        variant
      });
      icon = "checkmark";
      className = styles.success;
      break;
    case ExperimentStatusEnum.FAIL:
      label = i18n.t("experiments.status.fail");
      icon = "x";
      className = styles.fail;
      break;
  }
  return <div className={clsx(styles.status, className)} data-sentry-component="ExperimentStatus" data-sentry-source-file="index.tsx">
      <SvgIconReact className={styles.icon} icon={icon} data-sentry-element="SvgIconReact" data-sentry-source-file="index.tsx" />
      {showProgress && <SvgIconReact className={clsx(styles.icon, styles.progress)} style={{
      strokeDashoffset: -1.5 * PROGRESS_CIRCLE_RADIUS * Math.PI,
      strokeDasharray: "".concat(2 * percent * PROGRESS_CIRCLE_RADIUS * Math.PI, " ").concat(2 * (1 - percent) * PROGRESS_CIRCLE_RADIUS * Math.PI)
    }} icon='circle' />}
      <div className={styles.label}>{label}</div>
    </div>;
}